import * as i18n from '../i18n/I18n'

export function slugify(name: string) {
    if (name === null) return ''

    const plainName = i18n.removeDiacritics(name)

    return encodeURIComponent(
        plainName
            .toLowerCase()
            .trim()
            .replace('&', 'and')
            .replace(/[^a-z0-9 ]/g, '') // ignore special characters
            .replace(/[ ]+/g, '-')
    ) // replace whitespace with dash
}
